<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
        <div class="col-md-12">
            <div class="top-list-small-toolbar">
                <div>
                  <h4 class="text-primary">Laporan Laba Penjualan</h4>
                  <div class="form-inline ml-auto mb-auto">
                    <div class="button-group">
                      <!-- <span><b>Company:</b> </span> -->
                      <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                        <option value="">-- All --</option>
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                      </select>
                    </div>
                    <div class="button-group ml-1">
                      <!-- <span class="mr-1"><b>Date:</b> </span> -->
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                    </div>
                    <button type="button" class="btn btn-sm  btn-hard-primary ml-1" @click="refreshList">
                      <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row top-list-small-toolbar-margin">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-primary">Total HPP</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalCOGSRaw | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total HPP Retur</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalReturnCOGS | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-primary">Total HPP</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalCOGS | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-primary">Total Journal HPP</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalJournalHppRaw | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
      </div>
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-warning">Total Journal HPP Retur</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalJournalHppReturnRaw | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <ul class="nav nav-tabs nav-bordered">
              <li class="nav-item"><a href="#data" data-toggle="tab" aria-expanded="false" class="nav-link active">Data</a></li>
              <li class="nav-item"><a href="#raw" data-toggle="tab" aria-expanded="false" class="nav-link">Raw</a></li>
              <li class="nav-item"><a href="#sales-group" data-toggle="tab" aria-expanded="false" class="nav-link">Sales Group</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="data">
                <div class="table-responsive">
                  <table class="table table-item mb-0 table-sm table-hover table-striped">
                    <thead>
                      <th>Product</th>
                      <th>Qty</th>
                      <th>Uom</th>
                      <th class="text-right">COGS</th>
                      <th class="text-right">Sales</th>
                      <th class="text-right">Retur</th>
                      <th class="text-right">Profit/Loss</th>
                      <th>#</th>
                    </thead>
                    <tbody>
                      <tr v-for="(g, index) in groupData" :key="index">
                        <td><b>[{{ g.product_no }}]</b> {{ g.product }}</td>
                        <td>{{ g.qty | currency }} </td>
                        <td>{{ g.uom_id }}</td>
                        <td class="text-right">{{ g.totalCost | currency }}</td>
                        <td class="text-right">{{ g.totalSales | currency }}</td>
                        <td class="text-right">{{ g.totalRetur | currency }}</td>
                        <td class="text-right">{{ g.totalProfit | currency }}</td>
                        <td>
                          <a href="javascript:void(0)" class="text-success font-14">COGS</a> |
                          <a href="javascript:void(0)" class="text-success font-14">Sale</a>
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right">
                          <span class="font-14"><b>{{ totalProfit | currency }}</b></span>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="tab-pane" id="raw">
                <div class="table-responsive">
                  <div class="form-inline ml-auto">
                    <div class="button-group">
                      <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-filter" aria-hidden="true"></i>
                          Filter
                          <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu p-2" >
                        <span>Other:</span>
                        <div class="dropdown-divider"></div>
                        <li>
                          <a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" v-model="filterDiffCOGS" value="true"/> Diff COGS {{ filterDiffCOGS }}
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" v-model="filterDiffReturCOGS" value="true"/> Diff Retur COGS {{ filterDiffReturCOGS }}
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" v-model="filterType" value="sales"/> Sales
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" v-model="filterType" value="retur"/> Retur {{ filterType }}
                          </a>
                        </li>
                      </ul>
                    </div>
                    rows: {{ filterRaw.length }}
                  </div>
                  <table class="table table-item mb-0 table-sm table-hover table-striped">
                    <thead>
                      <th>#</th>
                      <th>Type</th>
                      <th>Date</th>
                      <th>Create Date</th>
                      <th>Journal Date</th>
                      <th>Ref No.</th>
                      <th>Product No.</th>
                      <th>Description</th>
                      <th>Uom</th>
                      <th>Qty</th>
                      <th class="text-right">Total sales</th>
                      <th class="text-right">Total COGS</th>
                      <th class="text-right">Total Retur</th>
                      <th class="text-right">Total Retur COGS</th>
                      <th class="text-right">Total Journal HPP</th>
                      <th class="text-right">Total Journal HPP Retur</th>
                    </thead>
                    <tbody>
                      <tr v-for="d in filterRaw" :key="d.id">
                        <td>
                          <button type="button" class="btn btn-sm btn-success" @click="setJournal(d.sale_id)"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                        </td>
                        <td>
                          <span class="badge badge-success" v-if="d.type === 'sales'">{{ d.type }}</span>
                          <span class="badge badge-warning" v-else>{{ d.type }}</span>
                        </td>
                        <td>{{ d.date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>
                          <span class="badge badge-danger" v-if="d.date !== d.create_date">{{ d.create_date | dateFormat('DD/MM/YYYY') }}</span>
                          <span>{{ d.create_date | dateFormat('DD/MM/YYYY') }}</span>
                        </td>
                        <td>
                          <span class="badge badge-danger" v-if="d.date !== d.journal_date">{{ d.journal_date | dateFormat('DD/MM/YYYY') }}</span>
                          <span>{{ d.journal_date | dateFormat('DD/MM/YYYY') }}</span>
                        </td>
                        <td>{{ d.ref_no }}</td>
                        <td>{{ d.product_no }}</td>
                        <td>{{ d.description }}</td>
                        <td>{{ d.uom_id }}</td>
                        <td>{{ d.qty }}</td>
                        <td class="text-right">{{ d.total_sales | currency }}</td>
                        <td class="text-right">{{ d.total_cost | currency }}</td>
                        <td class="text-right">{{ d.total_retur | currency }}</td>
                        <td class="text-right">{{ d.total_retur_cost | currency }}</td>
                        <td class="text-right">
                          <span class="badge badge-danger" v-if="d.total_journal_hpp !== d.total_cost">{{ d.total_journal_hpp | currency }}</span>
                          <span v-else>{{ d.total_journal_hpp | currency }}</span>
                        </td>
                        <td class="text-right">
                          <span class="badge badge-danger" v-if="d.total_journal_return !== d.total_retur_cost">{{ d.total_journal_return | currency }}</span>
                          <span v-else>{{ d.total_journal_return | currency }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="text-right">{{ totalCOGSRaw | currency }}</td>
                        <td class="text-right">{{ totalReturn | currency }}</td>
                        <td class="text-right">{{ totalReturnCOGS | currency }}</td>
                        <td class="text-right">{{ totalJournalHppRaw | currency }}</td>
                        <td class="text-right">{{ totalJournalHppReturnRaw | currency }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div class="tab-pane" id="sales-group">
                <span>Rows: {{ groupSale.length}}</span>
                <table class="table table-item mb-0 table-sm table-hover table-striped">
                  <thead>
                    <th>Ref no.</th>
                  </thead>
                  <tbody>
                    <tr v-for="g in groupSale" :key="g.ref_no">
                      <td>{{ g.ref_no }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-md-6"><pre>{{ dataRaw }}</pre></div> -->
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import Axios from 'axios'
import { getHeader, returnUrl, salesUrl } from '../../config'
import { mapState } from 'vuex'

export default {
  name: 'SaleReportLabaList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      filterCOGS: false,
      filterType: [],
      filterDiffCOGS: false,
      filterDiffReturCOGS: false,
      company_no: '',
      dataRaw: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      loadingSales: true
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    filterRaw () {
      return this.dataRaw.filter(d => {
        if (this.filterDiffCOGS === true) {
          if (d.total_journal_hpp !== d.total_cost) {
            return d
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterDiffReturCOGS === true) {
          if (d.total_journal_return !== d.total_retur_cost) {
            return d
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (d.type === this.filterType[i]) {
              return d
            }
          }
        } else {
          return d
        }
      })
    },
    totalReturn () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_retur)
      }
      return sum
    },
    totalReturnCOGS () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_retur_cost)
      }
      return sum
    },
    totalSales () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_sales)
      }
      return sum
    },
    totalCOGS () {
      var sum = 0
      sum = this.totalCOGSRaw - this.totalReturnCOGS
      return sum
    },
    totalCOGSRaw () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_cost)
      }
      return sum
    },
    totalJournalHppRaw () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal_hpp)
      }
      return sum
    },
    totalJournalHppReturnRaw () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal_return)
      }
      return sum
    },
    totalJournalHPP () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal_hpp) - parseFloat(array[i].total_journal_return)
      }
      return sum
    },
    totalProfitPlus () {
      var sum = 0
      var array = this.groupData
      for (let i = 0; i < array.length; i++) {
        if (array[i].totalProfit >= 0) {
          sum += Math.abs(parseFloat(array[i].totalProfit))
        }
      }
      return sum
    },
    totalProfitMinus () {
      var sum = 0
      var array = this.groupData
      for (let i = 0; i < array.length; i++) {
        if (array[i].totalProfit < 0) {
          sum += Math.abs(parseFloat(array[i].totalProfit))
        }
      }
      return sum
    },
    totalProfit () {
      var sum = 0
      var array = this.groupData
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].totalProfit)
      }
      return sum
    },
    groupData () {
      var result = []
      if (this.dataRaw.length > 0) {
        this.dataRaw.reduce(function (res, value) {
          var key = value.product_no
          var sales = parseFloat(value.total_sales) * parseFloat(value.qty)
          var cost = parseFloat(value.total_cost)
          var retur = parseFloat(value.total_retur)
          var profit = sales - retur - cost
          var journalHpp = parseFloat(value.total_journal_hpp)
          var journalHppRetur = parseFloat(value.total_journal_return)
          if (!res[key]) {
            res[key] = {
              product_no: value.product_no,
              product: value.description,
              uom_id: value.uom_id,
              qty: value.qty,
              totalSales: Math.round(sales),
              totalCost: Math.round(cost),
              totalProfit: Math.round(profit),
              totalRetur: Math.round(retur),
              totalJournalHpp: Math.round(journalHpp),
              totalJournalReturn: Math.round(journalHppRetur)
            }
            result.push(res[key])
          } else {
            res[key].qty = Math.round(parseFloat(res[key].qty) + parseFloat(value.qty))
            res[key].totalSales = Math.round(parseFloat(res[key].totalSales) + sales)
            res[key].totalCost = Math.round(parseFloat(res[key].totalCost) + cost)
            res[key].totalRetur = Math.round(parseFloat(res[key].totalRetur) + retur)
            res[key].totalProfit = Math.round(parseFloat(res[key].totalProfit) + profit)
            res[key].totalJournalHpp = Math.round(parseFloat(res[key].totalJournalHpp) + journalHpp)
            res[key].totalJournalReturn = Math.round(parseFloat(res[key].totalJournalReturn) + journalHppRetur)
          }
          return res
        }, {})
      }
      // return result
      var col = 'totalProfit'
      var ascending = false
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    groupSale () {
      var result = []
      if (this.dataRaw.length > 0) {
        this.dataRaw.reduce(function (res, value) {
          var key = value.ref_no
          if (!res[key]) {
            res[key] = {
              ref_no: key
            }
            result.push(res[key])
          }
          return res
        }, {})
      }
      // return result
      var col = 'totalProfit'
      var ascending = false
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    begin () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      return begin
    },
    end () {
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      return end
    },
    companyData () {
      var obj = {
        name: 'Ashahy',
        address: null,
        phone: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address,
          phone: cmp.phone
        }
      }
      return obj
    }
  },
  methods: {
    async setJournal (id) {
      this.$Progress.start()
      this.loader.isLoading = true
      var detail = this.dataRaw.find(d => d.sale_id === id)
      console.log(detail)
      if (detail.type === 'sales') {
        console.log(salesUrl + '/journal-stock-out/' + id)
        await Axios.get(salesUrl + '/journal-stock-out/' + id, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            this.$Progress.finish()
            this.loader.isLoading = false
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$Progress.fail()
            this.loader.isLoading = false
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      } else {
        var body = {
          id: id
        }
        await Axios.post(returnUrl + '/journal-sales/', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            this.$Progress.finish()
            this.loader.isLoading = false
          })
          .catch(error => {
            this.$Progress.fail()
            this.loader.isLoading = false
            console.log(error)
            console.log(error.response)
            throw error
          })
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(salesUrl + '/report-laba-sales')
      await Axios.post(salesUrl + '/report-laba-sales', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Report', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
